<div class="gap-top">
</div>

<!-- Loader -->
<!--<app-loader></app-loader> -->

<div class="container-fluid">
    <div class="row">
        <div class="col-xl-6">
            <div class="input-group">
                <div class="input-group-prepend">
                    <span class="input-group-text"><i class="fas fa-search mr-1"></i> </span>
                </div>
                <input autocomplete="off" type="text" class="form-control" (keyup)="applyFilter($event)"
                    placeholder="Search" aria-label="search">
            </div>
        </div>

        <div class="col-12 mt-2">
            <table mat-table [dataSource]="dataSource" class="gridData" matSort>
                <ng-container matColumnDef="privilegeName">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Privilege name</th>
                    <td mat-cell *matCellDef="let element"> {{element.description}} </td>
                </ng-container>
                <ng-container matColumnDef="privilegeDescription">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Privilege description</th>
                    <td mat-cell *matCellDef="let element"> {{element.description}} </td>
                </ng-container>
                <ng-container matColumnDef="status">
                    <th mat-header-cell *matHeaderCellDef mat-sort-header>Status</th>
                    <td mat-cell *matCellDef="let element"> {{element.status}} </td>
                </ng-container>
                <ng-container matColumnDef="action">
                    <th mat-header-cell *matHeaderCellDef>Action</th>
                    <td mat-cell *matCellDef="let element">
                        <button class="btn btn-sm btn-success mr-2" (click)="openMenuPrivilegeDialog(element)">
                            <i class="fas fa-check-circle mr-1"></i> Menu detail</button>
                        <mat-slide-toggle class="example-margin" color="primary" [checked]="element.status==='Active'"
                            (change)="onChange(element, $event.source.checked)">
                        </mat-slide-toggle>
                    </td>
                </ng-container>

                <tr mat-header-row *matHeaderRowDef="columnHeader"></tr>
                <tr mat-row *matRowDef="let row; columns: columnHeader;"></tr>
            </table>
        </div>
    </div>
</div>
